// extracted by mini-css-extract-plugin
export default {"container":"LoginForm_container__YDFcb","label":"LoginForm_label__F7sLE","inputContainer":"LoginForm_inputContainer__rhDXw","login":"LoginForm_login__RKJaD"};